import {
	createContext,
	ReactNode,
	useContext,
	useEffect,
	useState
} from 'react';
import { DataKey } from '../lib/model';
//import { useControls } from './ControlProvider';
import { useData } from './DataProvider';
import { groupBy } from 'lodash';
import { useRoute } from './RouteProvider';

export interface EdgeCaseContextInterface {
	listOfOffices: string[] | null;

	edgeCaseDataSorted: { [x: string]: { [x: string]: string }[] };
}

// eslint-disable-next-line react-refresh/only-export-components
export const EDGECASE_CONTEXT_DEFAULT: EdgeCaseContextInterface = {
	listOfOffices: [],
	edgeCaseDataSorted: {}
};

const EdgeCaseContext = createContext(EDGECASE_CONTEXT_DEFAULT);

// eslint-disable-next-line react-refresh/only-export-components
export function useEdgeCases() {
	return useContext<EdgeCaseContextInterface>(EdgeCaseContext);
}

export function EdgeCaseProvider({ children }: { children: ReactNode }) {
	const [listOfOffices, setListOfOffices] = useState<string[] | null>(
		EDGECASE_CONTEXT_DEFAULT.listOfOffices
	);
	const [edgeCaseDataSorted, setEdgeCaseDataSorted] = useState<{
		[x: string]: { [x: string]: string }[];
	}>(EDGECASE_CONTEXT_DEFAULT.edgeCaseDataSorted);

	const { stateEdgeCase10Data } = useData();
	const { election } = useRoute();

	useEffect(() => {
		if (election === 'state') {
			const groups = groupBy(
				stateEdgeCase10Data,
				(d: { [x: string]: string }) => d[DataKey.OfficeSought]
			);
			setEdgeCaseDataSorted(groups);
			const list = Object.keys(groups);
			setListOfOffices(list);
		}
	}, [election, stateEdgeCase10Data]);

	return (
		<EdgeCaseContext.Provider
			value={{
				listOfOffices,
				edgeCaseDataSorted
			}}
		>
			{children}
		</EdgeCaseContext.Provider>
	);
}
